export default "__VITE_ASSET__R59bp_Sf__"